import { Component, OnInit } from '@angular/core';

// services
import { PolicyDetailsService } from '@open-portal-app/core/services/policy-details.service';

@Component({
  selector: 'policy-landing',
  templateUrl: './policy-landing.component.html',
  styleUrls: ['./policy-landing.component.scss']
})
export class PolicyLandingComponent implements OnInit {
  policy!: any;
  isPolicyViewV2: any;

  constructor(
    private policyDetailsService: PolicyDetailsService
  ) {}

  ngOnInit(): void {
    this.policyDetailsService.formatPolicy().then((response: any) => {
      this.policy = response;
      this.isPolicyViewV2 = response.policyViewV2;
    });
  }
}